import http from '../http';
import Qs from 'qs';

// 年度学期列表
export const getTeaTermsListForEdu = params =>
  http.get('/yearTerms/listTerms', { params }).then(res => res.data);
// 删除年度学期
const delTeaTermsByForEdu = params =>
  http.delete('/yearTerms/term', { params }).then(res => res.data);
// 新增年度学期
const addTeaTermsByForEdu = params =>
  http({
    method: 'post',
    url: `/yearTerms/term`,
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then(res => res.data);
// 编辑年度学期
const editTeaTermsByForEdu = params =>
  http({
    method: 'put',
    url: `/yearTerms/term`,
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then(res => res.data);

// 运营用户删除
const delSysOperators = params =>
  http.delete('/sysOperators/operator', { params }).then(res => res.data);
// 运营用户修改密码
const editSysOperatorPwd = params =>
  http({
    method: 'put',
    url: `/sysOperators/operator/pwd`,
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then(res => res.data);
// 运营用户新增
const addSysOperator = params =>
  http({
    method: 'post',
    url: `/sysOperators/operator`,
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then(res => res.data);
// 运营用户编辑
const editSysOperator = params =>
  http({
    method: 'put',
    url: `/sysOperators/operator`,
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then(res => res.data);

// 服务管理-营养服务管理-教育局服务解除关联 v1.3.3废除
// const delorgByForEdu = params =>
//   http({
//     method: 'put',
//     url: `/orgEducationBureaus/edu/org`,
//     data: params,
//     headers: { 'Content-Type': 'application/json' }
//   }).then(res => res.data);
// 获取服务 合作教育局的年度学期（启用）
const getTermList = params =>
  http
    .get('/orgEducationBureaus/edu/org/term', { params })
    .then(res => res.data);

// 教育局-学校管理-学校列表
const getEduSchoolList = params =>
  http.get('/sysSchools/listSchools', { params }).then(res => res.data);
// http.get('/sysSchools/listSchoolsNew', { params }).then(res => res.data);

// 教育局-学校管理-学校列表(新)
const getEduSchoolListNew = params =>
  // http.get('/sysSchools/listSchools', { params }).then(res => res.data);
  http.get('/sysSchools/listSchoolsNew', { params }).then(res => res.data);

// 教育局-学校管理-导出全部数据
const getEduSchoolListData = params =>
  http
    .get('/sysSchools/exportSchoolsNew', { params, responseType: 'blob' })
    .then(res => res);

// 获取服务 合作教育局的列表
const getEduOrgList = params =>
  http.get('/orgEducationBureaus/edu/org', { params }).then(res => res.data);

// 服务管理-教育局管理详情
const getEducationBureauForEdu = params =>
  http.get('/educationBureau/educationBureau', { params }).then(res => res.data);

// 服务管理-教育局管理详情(新v1.3.1)
const getEducationBureauForEduNew = params =>
  http
    .get('/educationBureau/educationBureauNew', { params })
    .then(res => res.data);
// 服务管理-教育局管理详情-编辑
const editEdudetail = params =>
  http({
    method: 'put',
    url: `/educationBureau/edu/detail`,
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then(res => res.data);
// 服务管理-课班管理列表
const geteduClassPage = params =>
  http.get('/courseClass/eduClassPage', { params }).then(res => res.data);
// 服务管理-课班管理-详情
const getcourseClass = params =>
  http.get('/courseClass', { params }).then(res => res.data);
// http({
//   method: "get",
//   url: `/courseClass`,
//   data: { params },
//   headers: { "Content-Type": "application/json" }
// }).then(res => res.data);
// 查询消息列表
const getMsgList = params => http.get('/msg', { params }).then(res => res.data);
// 删除消息
const deletetMsg = params =>
  http.delete('/msg/code', { params }).then(res => res.data);
// 查询消息标签数量
const getMsgCount = params =>
  http.get('/msg/num', { params }).then(res => res.data);
// 消息设置已读
const setMsgRead = params =>
  http.put(`/msg/code`, Qs.stringify(params)).then(res => res.data);
// 设置全部消息已读
// const setAllMsgRead = (params) => http({method:'put',url:`/msg/all`, data:params,headers:{'Content-Type':'application/json'}}).then(res => res.data);
const setAllMsgRead = params =>
  http.put(`/msg/all`, Qs.stringify(params)).then(res => res.data);
// 消息待办审批
const setPassAudit = params =>
  http({
    method: 'put',
    url: `/educationBureau/passAudit`,
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then(res => res.data);

// 教育局- 数据概览
const getEduBasicData = params =>
  http.get('/stat/edu/view/edu/basicData', { params }).then(res => res.data);

// 教育局 - 考勤统计
const getEduSignData = params =>
  http.get('/stat/edu/view/edu/sign', { params }).then(res => res.data);

// 教育局 - 订餐统计
const getEduFoodData = params =>
  http.get('/stat/edu/org/edu/food', { params }).then(res => res.data);

// 教育局- 最受欢迎课班/托管TOP5
const getEduTop5Data = params =>
  http.get('/stat/edu/view/edu/top5', { params }).then(res => res.data);

// 教育局 - 今日数据
const getEduDayData = params =>
  http.get('/stat/edu/view/edu/day', { params }).then(res => res.data);

// 教育局 - 托管概览
const getEduTuoguanData = params =>
  http.get('/stat/edu/view/edu/tuoguan', { params }).then(res => res.data);

// 教育局 - 课程概览
const getEduCourseTypeData = params =>
  http.get('/stat/edu/view/org/courseType', { params }).then(res => res.data);

// 教育局 -学校 - 数据概览
const getEduSchBasicData = params =>
  http.get('/stat/edu/view/edu/sch/basicData', { params }).then(res => res.data);

// 教育局 -学校- 最受欢迎课班/托管TOP5
const getEduSchTop5Data = params =>
  http.get('/stat/edu/view/edu/sch/top5', { params }).then(res => res.data);

// 教育局 -学校 - 学校订餐统计
const getEduSchFoodData = params =>
  http.get('/stat/edu/org/edu/sch/food', { params }).then(res => res.data);

// 教育局 -学校 - 托管概览
const getEduSchTuoguanData = params =>
  http.get('/stat/edu/view/edu/sch/tuoguan', { params }).then(res => res.data);

// 教育局 -学校 - 课程概览
const getEduSchCourseTypeData = params =>
  http
    .get('/stat/edu/view/edu/sch/courseType', { params })
    .then(res => res.data);

// 教育局 -机构 - 数据概览
const getEduOrgBasicData = params =>
  http.get('/stat/edu/view/edu/org/basicData', { params }).then(res => res.data);

// 教育局 -机构 - 营收统计
const getEduOrgRevenueData = params =>
  http.get('/stat/edu/view/edu/revenue', { params }).then(res => res.data);

// 教育局 -机构- 最受欢迎课班/托管TOP5
const getEduOrgTop5Data = params =>
  http.get('/stat/edu/view/edu/org/top5', { params }).then(res => res.data);

// 教育局 -机构 - 学校订餐统计
const getEduOrgFoodData = params =>
  http.get('/stat/edu/org/edu/org/food', { params }).then(res => res.data);

// 教育局 -机构 - 托管概览
const getEduOrgTuoguanData = params =>
  http.get('/stat/edu/view/edu/org/tuoguan', { params }).then(res => res.data);

// 教育局 -机构 - 课程概览
const getEduOrgCourseTypeData = params =>
  http
    .get('/stat/edu/view/edu/org/courseType', { params })
    .then(res => res.data);

// 教育局 - 获取机构列表 v1.3.3
const getEduOrgListNew = params =>
  http.get('/orgEducationBureaus/edu/org/new', { params }).then(res => res.data);
// 查询教育局区域
const getEduAreaName = params =>
  http.get('/educationBureau/getEduAreaName', { params }).then(res => res.data);

// 查询大数据报告
export const getBigdataReport = params =>
  http.get('/bigdataReport/get', { params }).then(res => res.data);

// 查询基础平台数据字典
export const getByDictCode = params =>
  http.get('/dictionary/getByDictCode', { params }).then(res => res.data);

// 首页数据面板统计 报名人数
export const getStuEnrollNum = params =>
  http.get('/edu/enrollStatistic/getStuEnrollNum', { params }).then(res => res.data);
// 首页数据面板统计 获取报名人次
export const getEnrollNum = params =>
  http.get('/edu/enrollStatistic/getEnrollNum', { params }).then(res => res.data);
  // 首页数据面板统计 获取订购信息（未减去退款）
export const getPaymentInfo = params =>
  http.get('/edu/enrollStatistic/getPaymentInfo', { params }).then(res => res.data);
// 首页数据面板统计 获取退款信息
export const getRefundInfo = params =>
  http.get('/edu/enrollStatistic/getRefundInfo', { params }).then(res => res.data);
  // 首页数据面板统计 获取课程数
export const getCourseNum = params =>
  http.get('/edu/enrollStatistic/getCourseNum', { params }).then(res => res.data);
// 首页数据面板统计 获取开班数
export const getCourseClassNum = params =>
  http.get('/edu/enrollStatistic/getCourseClassNum', { params }).then(res => res.data);
  // 首页数据面板统计 获取总课节数
export const getCourseClassDetailNum = params =>
  http.get('/edu/enrollStatistic/getCourseClassDetailNum', { params }).then(res => res.data);
// 首页数据面板统计 按课程二级分类统计报名人数
export const statEnrollNumOfCourseTypeKind = params =>
  http.get('/edu/enrollStatistic/statEnrollNumOfCourseTypeKind', { params }).then(res => res.data);

// 首页数据面板统计 按课程二级分类统计开办数
export const statOpenClassNumOfCourseTypeKind = params =>
  http.get('/edu/enrollStatistic/statOpenClassNumOfCourseTypeKind', { params }).then(res => res.data);

// 首页数据面板统计 顶部学校人数统计
export const getStatisticInfoApi = params =>
  http.get('/sysTermBureauOrgs/getStatisticInfo', { params }).then(res => res.data);

export const sysTermBureauOrgsListApi = params =>
  http.get('/sysTermBureauOrgs/list', { params }).then(res => res.data);
export const sysTermBureauOrgsAddApi = params =>
  http({
    method: 'post',
    url: `/sysTermBureauOrgs/add`,
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then(res => res.data);

export const sysTermBureauOrgsUpdateApi = params =>
  http({
    method: 'post',
    url: `/sysTermBureauOrgs/update`,
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then(res => res.data);

export const sysTermBureauOrgslistOrgApi = params =>
  http.get('/sysTermBureauOrgs/listRelOrg', { params }).then(res => res.data);

export const sysTermBureauOrgsaddRelOrgApi = params =>
  http({
    method: 'post',
    url: `/sysTermBureauOrgs/addRelOrg`,
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then(res => res.data);

export const sysTermBureauOrgsupdateRelOrgApi = params =>
  http({
    method: 'post',
    url: `/sysTermBureauOrgs/updateRelOrg`,
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then(res => res.data);

export const sysTermBureauOrgsdeleteRelOrgApi = params =>
  http({
    method: 'post',
    url: `/sysTermBureauOrgs/deleteRelOrg`,
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then(res => res.data);

// 查询已关联的单位id列表
export const getExistListRelOrgApi = params =>
  http.get('/sysTermBureauOrgs/existListRelOrg', { params }).then(res => res.data);

// 查询教育局基础平台行政区域下学校
export const getEduRelBasicSchoolApi = params =>
  http.get('/edu/sysTermBureauOrgs/eduRelBasicSchool', { params }).then(res => res.data);

// 报名数据统计 - 教育局端、学校端
export const courseRegistrationDataApi = params =>
  http({
    method: 'post',
    url: `/theUserIdentity/enrollStatistic/courseRegistrationData`,
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then(res => res.data);

// 报名数据统计导出 - 教育局端、学校端
const courseRegistrationExportApi = (params, cancelToken) =>
  http
    .get('/theUserIdentity/enrollStatistic/exportCourseRegistrationData', {
      params,
      cancelToken,
      responseType: 'blob'
    })
    .then((res) => res);

// 学期学校和机构数 - 教育局端、学校端
export const termServiceSchoolNumberApi = params =>
  http({
    method: 'post',
    url: `/theUserIdentity/sysTermBureauOrgs/termServiceSchoolNumber`,
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then(res => res.data);

// 财务数据统计 - 教育局端、学校端
export const courseIncomeDataApi = params =>
  http({
    method: 'post',
    url: `/theUserIdentity/enrollStatistic/courseIncomeData`,
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then(res => res.data);

// 财务数据统计导出 -  教育局端、学校端
const exportCourseIncomeDataApi = (params, cancelToken) =>
  http
    .get('/theUserIdentity/enrollStatistic/exportCourseIncomeData', {
      params,
      cancelToken,
      responseType: 'blob'
    })
    .then((res) => res);

export default {
  sysTermBureauOrgsListApi,
  sysTermBureauOrgsAddApi,
  sysTermBureauOrgsUpdateApi,
  sysTermBureauOrgslistOrgApi,
  sysTermBureauOrgsaddRelOrgApi,
  sysTermBureauOrgsupdateRelOrgApi,
  sysTermBureauOrgsdeleteRelOrgApi,
  getStatisticInfoApi,
  statOpenClassNumOfCourseTypeKind,
  statEnrollNumOfCourseTypeKind,
  getCourseClassDetailNum,
  getCourseClassNum,
  getCourseNum,
  getRefundInfo,
  getEnrollNum,
  getStuEnrollNum,
  getPaymentInfo,
  getTeaTermsListForEdu,
  delTeaTermsByForEdu,
  addTeaTermsByForEdu,
  editTeaTermsByForEdu,
  delSysOperators,
  editSysOperatorPwd,
  addSysOperator,
  editSysOperator,
  // delorgByForEdu,
  getEducationBureauForEdu,
  getEducationBureauForEduNew,
  editEdudetail,
  geteduClassPage,
  getcourseClass,
  getMsgList,
  deletetMsg,
  getMsgCount,
  setMsgRead,
  setAllMsgRead,
  setPassAudit,
  getTermList,
  // 教育局首页
  getEduBasicData,
  getEduSignData,
  getEduTop5Data,
  getEduFoodData,
  getEduDayData,
  getEduTuoguanData,
  getEduCourseTypeData,
  // 学校数据统计
  getEduSchBasicData,
  getEduSchTop5Data,
  getEduSchFoodData,
  getEduSchTuoguanData,
  getEduSchCourseTypeData,
  // 机构数据统计
  getEduOrgBasicData,
  getEduOrgRevenueData,
  getEduOrgTop5Data,
  getEduOrgFoodData,
  getEduOrgTuoguanData,
  getEduOrgCourseTypeData,

  getEduOrgList,
  getEduSchoolList,
  getEduSchoolListNew,
  getEduSchoolListData,

  getEduOrgListNew,
  getEduAreaName,
  getExistListRelOrgApi,
  getEduRelBasicSchoolApi,
  courseRegistrationDataApi,
  termServiceSchoolNumberApi,
  courseIncomeDataApi,
  courseRegistrationExportApi,
  exportCourseIncomeDataApi,
  getByDictCode
};
